import api from './api';
import { cachedGet, invalidate } from './apiCache';
import { Employee } from '../types/employees.types';

const employeesService = {
  getAll: (includeInactive: boolean = false) =>
    cachedGet(`employees_all_${includeInactive}`,
      () => api.get<Employee[]>(`/Employees${includeInactive ? '?includeInactive=true' : ''}`)),
  getById: (id: number) => api.get<Employee>(`/Employees/${id}`),
  create: (data: Employee) => { invalidate('employees_'); return api.post<Employee>('/Employees', data); },
  update: (id: number, data: Employee) => { invalidate('employees_'); return api.put(`/Employees/${id}`, data); },
  delete: (id: number) => { invalidate('employees_'); return api.delete(`/Employees/${id}`); },
  terminate: (id: number, payload: { terminationDate: string; terminationType: string; reason?: string }) => {
    invalidate('employees_');
    return api.post(`/Employees/${id}/terminate`, payload);
  },
  reinstate: (id: number) => { invalidate('employees_'); return api.post(`/Employees/${id}/reinstate`, {}); },
  generateEmployeeCode: () => api.get<string>('/Employees/generate-employee-code'),
  getForTimeSheet: (branchId?: number) => {
    const url = branchId ? `/Employees/for-timesheet?branchId=${branchId}` : '/Employees/for-timesheet';
    return cachedGet(`employees_timesheet_${branchId}`, () => api.get<{ data: Employee[] }>(url));
  },
};

export default employeesService;